import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";

import { useCallbackPrompt } from "~/hooks/useCallbackPrommpt";
import VerticalStepper from "~/components/stepper";
import ConfirmationDialog from "~/components/confirmation-dialog/ConfirmationDialog";
import "../../employee.scss";
import PersonalInformation from "../PersonalInformation";
import useEmployeeRegistry from "../../useEmployeeRegistry";
import usePersonalInformation from "../PersonalInformation/usePersonalInformation";
import CustomeButton from "~/components/Button";
import EmployeeLayout from "../EmployeeLayout";
import LocationAddress from "../LocationAddress";
import useEmployeeAddress from "../../actions/useEmployeeAddress";
import EmploymentInformation from "../EmploymentInformation";
import useEmploymentInformation from "../../actions/useEmploymentInformation";
import useBankInformation from "../../actions/useBankInformation";
import BankInformation from "../BankInformation";

const EmployeeOnboarding = () => {
  const navigate = useNavigate();

  const { onChangePersonalInfo, personalInformation } =
    usePersonalInformation();

  const {
    employeeregister,
    handleNext,
    handleBack,
    handleClearState,
    handleSave,
    loading,
    submit,
    addNewEmployee,
    handleClose,
  } = useEmployeeRegistry();
  const { onChangeAddress, address, statesarray, cityarray } =
    useEmployeeAddress();
  const {
    onChangeEmploymentInformation,
    employmentInformation,
    isIdAvailable,
  } = useEmploymentInformation();
  const { bankInformation, onChangeBankInformation } = useBankInformation();

  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
    employeeregister?.isLeaveModal,
  );

  const handleLeaveConfirm = () => {
    handleClearState();
    confirmNavigation();
  };

  const steps = [
    {
      label: "Personal Information",
      content: (
        <PersonalInformation
          handleChange={onChangePersonalInfo}
          personalInformation={personalInformation}
        />
      ),
    },
    {
      label: "Location & Address",
      content: (
        <LocationAddress
          handleChange={onChangeAddress}
          data={address}
          states={statesarray}
          cities={cityarray}
        />
      ),
    },
    {
      label: "Employment Information",
      content: (
        <EmploymentInformation
          handleChange={onChangeEmploymentInformation}
          employmentInformation={employmentInformation}
          isIdAvailable={isIdAvailable}
        />
      ),
    },
    {
      label: "Bank Information",
      content: (
        <BankInformation
          handleChange={onChangeBankInformation}
          bankInformation={bankInformation}
          submit={submit}
          addNewEmployee={addNewEmployee}
          handleClose={handleClose}
        />
      ),
    },
  ];
  return (
    <EmployeeLayout isOnboarding={true}>
      <div className="grid employee_registry">
        <div className="lg:col-3 md:col-12 sm:col-12 xs:col-12 pt-4">
          <Card className="h-full">
            <p className="heading">Add New Employee</p>
            <p className="description m-0">
              Complete the necessary steps to add a new Employee to this
              company.
            </p>
            <Divider />
            <div className="step-menu">
              <VerticalStepper
                options={steps}
                activeIndex={employeeregister?.activeIndex}
              />
            </div>
          </Card>
        </div>
        <div className="lg:col-9 md:col-12 sm:col-12 xs:col-12 pt-4">
          <Card className="card-onboard">
            {steps[employeeregister?.activeIndex]?.content}
          </Card>
          {!submit && (
            <div
              className={`next-btn-footer ${employeeregister?.activeIndex === 0 ? "flex-row-reverse" : ""}`}
            >
              {employeeregister?.activeIndex !== 0 ? (
                <>
                  <div className="d-flex justify-content-start">
                    <button
                      type="button"
                      className="generic-cancel"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              ) : null}
              <div className="flex justify-content-end gap-2">
                {employeeregister?.activeIndex === 0 ? (
                  <button
                    type="button"
                    className="cancel-btns"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    Cancel
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={handleBack}
                    disabled={employeeregister?.activeIndex === 0}
                    className="cancel-btns"
                  >
                    Back
                  </button>
                )}
                <CustomeButton
                  label={"Next"}
                  type="submit"
                  iconPos="right"
                  onClick={() => {
                    employeeregister?.activeIndex === steps.length - 1
                      ? handleSave()
                      : handleNext();
                  }}
                  loading={loading}
                  disabled={
                    !employeeregister?.nextBtnEnable || loading || isIdAvailable
                  }
                  className={`add-new-lsp  ${(!employeeregister?.nextBtnEnable || isIdAvailable) && "disable"}`}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {showPrompt && (
        <ConfirmationDialog
          show={showPrompt}
          onConfirm={handleLeaveConfirm}
          onCancel={cancelNavigation}
        />
      )}
    </EmployeeLayout>
  );
};

export default EmployeeOnboarding;
